import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 60%;
  max-width: 600px;
  max-height: 70%;

  .header-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .content {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 16px;
  }

  .bottom-buttons-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    button {
      width: 100%;
    }
  }

  ${({ theme }) => css`
    padding: ${theme.padding.default};
    border-radius: ${theme.borderRadius.biggest};
    background: rgba(108, 109, 106, 0.05);
    backdrop-filter: blur(10px);

    ::before {
      content: '';
      position: absolute;
      z-index: -1;
      inset: 0;
      padding: 1.5px;
      border-radius: ${theme.borderRadius.biggest};
      background: linear-gradient(
        to bottom right,
        rgba(255, 255, 255, 0.1),
        rgba(255, 255, 255, 0)
      );
      -webkit-mask: linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
    }

    .bottom-buttons-container {
      gap: ${theme.padding.default};
      margin-top: ${theme.padding.biggest};
    }
  `}
`;
